const DownloadOutlined = ({ fill = '#25314C' }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'>
    <path
      fill={fill}
      d='M4.94 7.893a.438.438 0 1 1 .62-.62l1.003 1.004V1.75a.438.438 0 0 1 .875 0v6.527l1.003-1.003a.438.438 0 1 1 .62.619l-1.75 1.75a.44.44 0 0 1-.478.094.4.4 0 0 1-.142-.094zm5.56-2.497a.438.438 0 0 0 0 .875c.92 0 1.313.392 1.313 1.312V10.5c0 .92-.393 1.313-1.313 1.313h-7c-.92 0-1.312-.393-1.312-1.313V7.583c0-.92.392-1.312 1.312-1.312a.438.438 0 0 0 0-.875c-1.41 0-2.187.777-2.187 2.187V10.5c0 1.41.777 2.188 2.187 2.188h7c1.41 0 2.188-.777 2.188-2.188V7.583c0-1.41-.777-2.187-2.188-2.187'
    />
  </svg>
);

export default DownloadOutlined;
